import { type ComponentPropsWithRef, useState } from "react";
import { Slider } from "./shadcn/slider";

/**
 * Sometimes, when form is submitted (server action), the input values are reset.
 * This component keeps a copy of the input value in the component state to prevent this.
 * Honestly speaking, I don't know why this happens. Didn't want to waste time debugging it.
 * When we fix the issue, we can remove this component. - Michał
 */
export const StatefulSlider = ({
	value,
	onValueChange,
	defaultValue,
	...props
}: ComponentPropsWithRef<typeof Slider>) => {
	const [state, setState] = useState(value || defaultValue);

	return (
		<div className="flex items-center gap-x-2">
			<Slider
				{...props}
				value={state}
				onValueChange={(value) => {
					setState(value);
					onValueChange?.(value);
				}}
			/>
			<span>{state}</span>
		</div>
	);
};
